import React from 'react'
import SectionHeroBanner from '../sections/SectionHeroBanner';
import SectionBasicContainer from '../sections/SectionBasicContainer';
import SectionHeroBannerFixed from '../sections/SectionHeroBannerFixed';
import SectionHeroBannerDynamic from '../sections/SectionHeroBannerDynamic';
import SectionBasicEmptyContainer from '../sections/SectionBasicEmptyContainer';

const SectionLoader = ( { item, collectionSettings } ) => {
    const sectionMap = {
        SectionHeroBanner,
        SectionBasicContainer,
        SectionHeroBannerFixed,
        SectionHeroBannerDynamic,
        SectionBasicEmptyContainer
    };
    let Component = sectionMap[item.component] || null
    if(Component) {
        return (
            <Component 
                key={item.id}
                settings={item.settings}
                contentType={item.contentType}
                contentCollection={item.contentCollection}
                collectionSettings={collectionSettings}
            />
        )
    } else {
        console.log(`Compontent ${item.component} not found`)
    }
}

export default SectionLoader